import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { TrendsRadarProvider as Provider } from '@shapeable/gesda-ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllTrendsRadarQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Trends" } }) {
    nodes {
      data
    }
  }
}
`;

export const TrendsRadarProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};